/// <reference path="../../typings/browser.d.ts" />

namespace Application.Common {
   'use strict';
   
    export interface ISelectizeStringString {
        value: string;
        string: string;
    }
}